import { useState, useEffect } from 'react';
import { useStreamlineContext } from '../contexts/ContextProvider';
import config from '../config';

function lookupTabByStatus(status, streamlineMode) {
  if (status['Status'] === '') {
    return '';
  }
  const tableObj = streamlineMode
    ? config.tabByStatus.streamline
    : config.tabByStatus.original;
  const tabObj = tableObj[status['Status']];

  if (typeof tabObj === 'string') {
    return tabObj;
  }
  return tabObj[status['Detailed Status']];
}

export default function useSelectedTab(status) {
  const streamlineMode = useStreamlineContext();
  const [selectedTab, setSelectedTab] = useState();

  useEffect(() => {
    if (status) {
      setSelectedTab(lookupTabByStatus(status, streamlineMode));
    }
  }, [status, streamlineMode]);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  return [selectedTab, handleTabChange];
}
